module.exports = __webpack_public_path__ + "img/ht.ht7979dcf.svg";